// extracted by mini-css-extract-plugin
module.exports = {"YXHContract":"index-module_YXHContract_1tLmg","title":"index-module_title_1lxeU","idCard":"index-module_idCard_kn8c3"};